import {BaseService} from './baseService.js';
import {Service} from './service.js';

/* 
 * Handles interaction with the user message api
 */
export class UserMessageService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async getUserMessages(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		var data = await this.makeGETRequest('/api/resource/user-messages' + params);		
		return data;
	}

	exportUserMessages(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/user-messages/export' + params);
	}
	
	async cleanupOldMessages() {	
		var result = await this.makePUTRequest('/api/resource/user-messages/cleanold');
		return result;
	}	

	async processMessageNow() {	
		var result = await this.makePUTRequest('/api/resource/user-messages/processnow');
		return result;
	}
	
	async deleteMessage(userMessageId) {		
		var result = await this.makeDELETERequest('/api/resource/user-messages/' + userMessageId);		
		return result;
	}
	
}

